import React, {useEffect, useState} from 'react';
import Slider from '@material-ui/core/Slider';
import { withStyles } from '@material-ui/core/styles';

const styles = {
    root: {
        width: '250px', marginRight: '10px',
    },
    valueLabel: {
        top: '40px',
    },
    // '.PrivateValueLabel-circle-130': {
    //     borderRadius: '50% 0 50% 50%',
    // }
};

function ZoomSlider(props){
    const { classes } = props;

    const [sliderValue, setSliderValue] = useState(100);

    function changeSlider(e, value){
        setSliderValue(value);
        window.localStorage.setItem('app_zoom', value);
    }

    useEffect(() => {
        let zoom = window.localStorage.app_zoom;
        if(zoom === undefined){
            window.localStorage.setItem('app_zoom', 100);
            return
        }
        setSliderValue(parseInt(zoom));
    }, []);

    useEffect(() => {
        let main = document.querySelector('HTML');
        if(main !== null){
            main.style.zoom = `${sliderValue}%`;
        }
    }, [sliderValue]);

    return <Slider 
        value={sliderValue}
        onChange={changeSlider}
        getAriaValueText={value => value}
        aria-labelledby="discrete-slider"
        valueLabelDisplay="auto"
        step={5}
        marks
        min={65}
        max={100}
        classes={classes}
    />
}

export default withStyles(styles)(ZoomSlider)